module.exports = __webpack_public_path__ + "static/media/two.4251c11a.JPG";